import { useApp } from "@/lib/AppContext";

export default function LangThemeToggle({ variant = "default" }) {
  const { lang, theme, toggleLang, toggleTheme } = useApp();

  const isDark = theme === "dark";
  const isLight = !isDark;

  const base = variant === "sidebar"
    ? "flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-all"
    : "flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-bold border transition-all";

  const langClass = variant === "sidebar"
    ? "bg-sidebar-accent text-sidebar-foreground hover:bg-sidebar-primary hover:text-white"
    : "bg-white/90 dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-foreground hover:border-primary";

  const themeClass = variant === "sidebar"
    ? "bg-sidebar-accent text-sidebar-foreground hover:bg-sidebar-primary hover:text-white"
    : "bg-white/90 dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-foreground hover:border-primary";

  return (
    <div className="flex items-center gap-2">
      {/* Language Toggle */}
      <button onClick={toggleLang} className={`${base} ${langClass}`} title="Switch Language">
        <span className="text-base">{lang === "ar" ? "🇸🇦" : "🇺🇸"}</span>
        <span>{lang === "ar" ? "EN" : "عر"}</span>
      </button>

      {/* Theme Toggle */}
      <button onClick={toggleTheme} className={`${base} ${themeClass}`} title="Toggle Theme">
        <span className="text-base">{isDark ? "☀️" : "🌙"}</span>
        <span className="hidden sm:inline">{isDark ? (lang === "ar" ? "فاتح" : "Light") : (lang === "ar" ? "داكن" : "Dark")}</span>
      </button>
    </div>
  );
}